import Vue from 'vue'

import lang from 'quasar/lang/ru.js'
import 'quasar/src/css/index.sass'
import './variables.scss'
import '@quasar/extras/line-awesome/line-awesome.css'

import {
  Quasar,
  QLayout,
  QHeader,
  QDrawer,
  QPageContainer,
  QPage,
  QToolbar,
  QToolbarTitle,
  QBtn,
  QIcon,
  QList,
  QItem,
  QItemSection,
  QItemLabel,
  QScrollArea,
  QInnerLoading,
  QSpinnerDots,
  QSeparator,
  QTable,
  QTh,
  QTr,
  QTd,
  QInput,
  Ripple,
  QSpace,
  QSplitter,
  QToggle,
  QSelect,
  QTabPanels,
  QTabPanel,
  QTabs,
  QTab,
  QCard,
  QImg,
  QBtnToggle,
  QOptionGroup,
  QTooltip,
  QMenu,
  QDialog,
  QCardSection,
  QCardActions,
  QPopupEdit,
  QForm,
  QAvatar,
  ClosePopup,
  QBadge,
  QTimeline,
  QTimelineEntry,
  QPopupProxy,
  QCheckbox,
  Notify,
} from 'quasar'

Vue.use(Quasar, {
  config: {},
  components: {
    Quasar,
    QLayout,
    QHeader,
    QDrawer,
    QPageContainer,
    QPage,
    QToolbar,
    QToolbarTitle,
    QBtn,
    QIcon,
    QList,
    QItem,
    QItemSection,
    QItemLabel,
    QScrollArea,
    QInnerLoading,
    QSpinnerDots,
    QSeparator,
    QTable,
    QTh,
    QTr,
    QTd,
    QInput,
    QSpace,
    QSplitter,
    QToggle,
    QSelect,
    QTabPanels,
    QTabPanel,
    QTabs,
    QTab,
    QCard,
    QImg,
    QBtnToggle,
    QOptionGroup,
    QTooltip,
    QMenu,
    QDialog,
    QCardSection,
    QCardActions,
    QPopupEdit,
    QForm,
    QAvatar,
    QBadge,
    QTimeline,
    QTimelineEntry,
    QPopupProxy,
    QCheckbox,
  },
  directives: { Ripple, ClosePopup },
  plugins: { Notify },
  lang: lang,
})
